<template>
  <common-dialog ref="dialog" :title="title" width="1000px" @closed="onClosed">
    <el-table size="mini" :data="data" stripe border>
      <el-table-column prop="DormitoryAddr" label="宿舍地址" />
      <el-table-column prop="DormitoryNumber" label="房号" />
      <el-table-column prop="Capacity" label="容纳人数" />
      <el-table-column prop="CreateTime" label="创建时间" min-width="100">
        <template slot-scope="{row}">
          <span>{{$commonJs.toDateString(row.CreateTime)}}</span>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-button size="mini" type="primary" @click="onExport">导 出</el-button>
      <el-button size="mini" @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [detailsDialogMixin],
  components: { commonDialog },
  data() {
    return {
      api: require("@/api/lo/dorm").default,
      data: [],
      params: {},
      title: "导出 宿舍信息",
    };
  },
  methods: {
    getData(params) {
      this.params = params;
      this.$refs.dialog.isLoading = true;
      this.api.list(params).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) this.data = res.Data;
      });
    },
    onExport() {
      this.api.export(this.params);
    },
    onClosed() {
      this.data = [];
      this.params = {};
    },
  },
};
</script>